import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { FigureSolidDashKpiProviders } from "./categoryChartData.types";
import _ from "lodash";
import { getKpisForProvidersWithCategoryChart } from "../opendata";
import { EMPTY_ARRAY, extractComparionChartData, getFigureAndSolidDashGraph } from "../misc";
import { getWaterSuppliedPerResidentialConnection } from "./fetchFigureWaterSuppliedPerResidentialConnectionChartData";

export const fetchFigureWaterSuppliedPerResidentialConnectionComparisonChartData: CategoryChartQueryFn = async ({
    metadata,
    categoryChart,
    providers,
    kpis,
    category
}: CategoryChartQueryParam): Promise<FigureSolidDashKpiProviders> => {
    if (!metadata || !providers || providers?.length === 0 || !categoryChart || !kpis || kpis?.length === 0)
        return null;

    let kpiReportResults = await getKpisForProvidersWithCategoryChart(kpis, providers, true, categoryChart);

    const { displayTitle, visType } = categoryChart;
    kpiReportResults = (kpiReportResults ?? []).filter(d => d != null && d.provider != null);

    const residentialPotableWaterSupplyKpi = kpis?.[0]?.[0];
    const residentialConnectionSizeKpis = kpis.filter((__, index) => index > 0).map(d => d?.[0]);

    if (!residentialPotableWaterSupplyKpi || !residentialConnectionSizeKpis) return null;

    const residentialConnectionSizeKpiMap = residentialConnectionSizeKpis.reduce((prev, cur) => {
        prev[cur] = 1;
        return prev;
    }, {});

    const years = _.uniq(
        _.flattenDeep(
            _.values(_.groupBy(kpiReportResults, d => d?.provider?.tid)).map(results => {
                const years = _.orderBy(_.uniq(results.map(d => d.year)), d => d, "asc") ?? (EMPTY_ARRAY as number[]);
                const yearsToResults = _.groupBy(results, d => d.year);
                const startYear = years.find(
                    year =>
                        yearsToResults?.[year]?.find(
                            res => res.kpiCode === residentialPotableWaterSupplyKpi && res.value != null
                        ) &&
                        yearsToResults?.[year]?.filter(
                            res => residentialConnectionSizeKpiMap[res.kpiCode] === 1 && res.value != null
                        )?.length > 0
                );

                return startYear == null ? [] : years.filter(y => y >= startYear);
            })
        )
    );

    // const years = _.orderBy(_.uniq(kpiReportResults.map(d => d.year)), d => d, "asc") ?? EMPTY_ARRAY;

    const _chartData = providers.map((provider, providerIndex) => {
        return {
            connectionSizeCategory: provider?.connectionSizeCategory,
            data: getFigureAndSolidDashGraph(
                metadata,
                provider,
                kpiReportResults,
                kpis,
                categoryChart,
                category,
                "%",
                getWaterSuppliedPerResidentialConnection,
                years,
                providerIndex
            )
        };
    });

    if (!_chartData || _chartData?.length === 0) return null;

    const {
        years: displayedYears,
        displayedAverageData,
        displayedLinesData,
        header,
        footer,
        measure,
        latestYear,
        unit,
        figures,
        providerMedianAnnotations,
        providerMedianSeriesNames
    } = extractComparionChartData(categoryChart, _chartData);

    // const chartData = _chartData?.map(d => d.data);

    // const figures = chartData.map(d => d.figure);

    // const providerMedianData = _.uniqBy(_chartData, d => d.connectionSizeCategory).map(d => {
    //     return d?.data?.graph?.providerMedianData;
    // });

    // const providerMedianSeriesNames = _.uniqBy(_chartData, d => d.connectionSizeCategory).map(d => {
    //     return d?.data?.graph?.providerMedianSeriesName;
    // });

    // const providerMedianAnnotations = _.uniqBy(_chartData, d => d.connectionSizeCategory).map(d => {
    //     return d?.data?.graph?.providerMedianAnnotation;
    // });

    return {
        title: displayTitle,
        kpiCode: null,
        schemeType: kpis?.[0]?.[1],
        waterProviders: providers,
        unit,
        year: latestYear,
        figures: !(visType === "figureWithSolidDashLine") ? null : figures,
        graph:
            visType === "figure"
                ? null
                : {
                      measure,
                      header,
                      footer,
                      years: displayedYears,
                      //   largeProviderAverageData: chartData?.[0]?.graph?.largeProviderAverageData,
                      //   largeProviderAverageSeriesName: chartData?.[0]?.graph?.largeProviderAverageSeriesName,
                      providerMedianData: displayedAverageData,
                      providerMedianSeriesNames,
                      providerMedianAnnotations,
                      linesData: displayedLinesData,
                      linesDataSeriesName: providers.map(provider => provider.name)
                      // chartData?.map(d => d?.graph?.lineDataSeriesName).filter(d => d != null) ?? EMPTY_ARRAY
                  }
    };
};
